import { render, staticRenderFns } from "./CtgAnalizatorPage.vue?vue&type=template&id=631fb9f5"
import script from "./CtgAnalizatorPage.vue?vue&type=script&lang=js"
export * from "./CtgAnalizatorPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports